import { render, staticRenderFns } from "./Situation.vue?vue&type=template&id=632f292e&scoped=true"
import script from "./Situation.vue?vue&type=script&lang=js"
export * from "./Situation.vue?vue&type=script&lang=js"
import style0 from "./Situation.vue?vue&type=style&index=0&id=632f292e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632f292e",
  null
  
)

export default component.exports